const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  error: null,
  data: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'USER_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'USER_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload.data,
      }

    case 'USER_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        data: action.payload.data,
      }

    default:
      return state
  }
}
